import { render } from "./CodingSimulationPanel.vue?vue&type=template&id=c963cba8&scoped=true"
import script from "./CodingSimulationPanel.vue?vue&type=script&lang=js"
export * from "./CodingSimulationPanel.vue?vue&type=script&lang=js"

import "./CodingSimulationPanel.vue?vue&type=style&index=0&id=c963cba8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c963cba8"]])

export default __exports__